import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingSpinner from "@/components/common/LoadingSpinner"; // your reusable spinner
import {
  selectIsAuthenticated,
  selectAuthLoading,
  selectHasValidSession,
  selectAuthInitializing,
} from "../../store/selectors/authSelectors";

const ProtectedRoute = ({
  children,
  requireAuth = true,
  redirectTo = "/login",
  requireAdmin = false,
}) => {
  // ---- Hooks (must run first) ----
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const initializing = useSelector(selectAuthInitializing);
  const hasValidSession = useSelector(selectHasValidSession);
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();

  useEffect(() => {
    // Only show error toast if we're not initializing and auth check is complete
    if (
      !initializing &&
      requireAuth &&
      (!isAuthenticated || !hasValidSession)
    ) {
      toast.success("Page access denied: Need Valid Session / Login");
    }
  }, [requireAuth, isAuthenticated, hasValidSession, initializing]);

  // ---- Conditional rendering ----
  // Show loading spinner while auth is loading OR initializing
  // if (loading || initializing) {
  if (initializing) {
    return <LoadingSpinner fullscreen text="Verifying your session..." />;
  }

  // Only redirect if auth check is complete (not initializing) and user is not authenticated
  if (requireAuth && (!isAuthenticated || !hasValidSession)) {
    console.log(
      "ProtectedRoute: No valid session, redirecting to:",
      redirectTo
    );
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (
    requireAdmin &&
    (!user || (user.role !== "admin" && user.role !== "super_admin"))
  ) {
    console.log(
      "ProtectedRoute: Insufficient permissions, redirecting to home"
    );
    return <Navigate to="/admin" replace />;
  }

  console.log("ProtectedRoute: Access granted");
  return children;
};

export default ProtectedRoute;
